import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, CheckCircle2 } from 'lucide-react';
const ARGENTINE_NAMES = ['Guadalupe', 'Carlos', 'Fernanda', 'José', 'Valentina', 'Miguel', 'Sofía', 'Andrés', 'Camila', 'Roberto', 'Luciana', 'Martín', 'Florencia', 'Nicolás', 'Agustina', 'Facundo', 'Julieta', 'Tomás', 'Rocío', 'Matías'];
const ARGENTINE_CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Tucumán', 'Mar del Plata', 'Salta', 'Santa Fe', 'San Juan', 'Resistencia', 'Neuquén', 'Posadas', 'Bahía Blanca', 'Paraná', 'San Luis', 'Corrientes', 'San Miguel de Tucumán', 'Río Cuarto', 'Tandil'];
const TIMES = ['2 min', '3 min', '5 min', '6 min', '7 min', '9 min', '12 min', '15 min', '18 min', '22 min'];
const COLOR_SCHEMES = [{
  bg: 'bg-gradient-to-r from-green-400 to-emerald-500',
  text: 'text-white',
  subtext: 'text-green-50',
  border: 'border-emerald-400',
  shadow: 'shadow-emerald-500/50'
}, {
  bg: 'bg-gradient-to-r from-blue-500 to-indigo-600',
  text: 'text-white',
  subtext: 'text-blue-100',
  border: 'border-indigo-400',
  shadow: 'shadow-indigo-500/50'
}, {
  bg: 'bg-gradient-to-r from-purple-500 to-pink-500',
  text: 'text-white',
  subtext: 'text-purple-100',
  border: 'border-pink-400',
  shadow: 'shadow-pink-500/50'
}, {
  bg: 'bg-gradient-to-r from-orange-400 to-red-500',
  text: 'text-white',
  subtext: 'text-orange-100',
  border: 'border-red-400',
  shadow: 'shadow-red-500/50'
}, {
  bg: 'bg-gradient-to-r from-yellow-400 to-amber-500',
  text: 'text-gray-900',
  subtext: 'text-gray-800',
  border: 'border-amber-400',
  shadow: 'shadow-amber-500/50'
}, {
  bg: 'bg-gradient-to-r from-cyan-400 to-blue-500',
  text: 'text-white',
  subtext: 'text-cyan-50',
  border: 'border-blue-400',
  shadow: 'shadow-blue-500/50'
}, {
  bg: 'bg-gradient-to-r from-rose-500 to-red-600',
  text: 'text-white',
  subtext: 'text-rose-100',
  border: 'border-red-400',
  shadow: 'shadow-red-500/50'
}, {
  bg: 'bg-gradient-to-r from-teal-400 to-green-500',
  text: 'text-white',
  subtext: 'text-teal-50',
  border: 'border-green-400',
  shadow: 'shadow-green-500/50'
}];
function generatePurchases() {
  return ARGENTINE_NAMES.map((name, i) => ({
    name,
    city: ARGENTINE_CITIES[i % ARGENTINE_CITIES.length],
    country: 'Argentina',
    time: TIMES[i % TIMES.length]
  }));
}
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isDismissed, setIsDismissed] = useState(false);
  const [purchases] = useState(generatePurchases());
  useEffect(() => {
    if (isDismissed) return;
    const initialTimeout = setTimeout(() => {
      setIsVisible(true);
    }, 5000);
    const cycleInterval = setInterval(() => {
      if (isDismissed) return;
      setIsVisible(false);
      setTimeout(() => {
        if (isDismissed) return;
        setCurrentIndex(prev => (prev + 1) % purchases.length);
        setIsVisible(true);
      }, 2000);
    }, 8000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(cycleInterval);
    };
  }, [isDismissed, purchases.length]);
  useEffect(() => {
    if (isVisible && !isDismissed) {
      const hideTimeout = setTimeout(() => {
        setIsVisible(false);
      }, 5000);
      return () => clearTimeout(hideTimeout);
    }
  }, [isVisible, isDismissed]);
  if (isDismissed) return null;
  const currentPurchase = purchases[currentIndex];
  const currentScheme = COLOR_SCHEMES[currentIndex % COLOR_SCHEMES.length];
  return <AnimatePresence data-id="element-196">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 40,
      x: -10
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      x: -10
    }} transition={{
      duration: 0.4
    }} className="fixed bottom-3 left-3 z-50 max-w-[280px] w-full" data-id="element-197">
          <div className={`${currentScheme.bg} rounded-lg shadow-xl ${currentScheme.shadow} border-2 ${currentScheme.border} px-3 py-3 flex items-center gap-3 relative overflow-hidden`} data-id="element-198">
            <button onClick={() => setIsDismissed(true)} className={`absolute top-1 right-1 ${currentScheme.text} opacity-60 hover:opacity-100 p-0.5`} data-id="element-199">
              <X size={14} data-id="element-200" />
            </button>

            <div className="flex-shrink-0 relative" data-id="element-201">
              <img src="https://cdn.magicpatterns.com/uploads/hgeXh4nfV8dAh1AweTPm4o/mockups_metodologia_de_la_investigacion.png" alt="Product" className="w-12 h-12 object-cover rounded border-2 border-white/30" data-id="element-202" />
              <div className="absolute -bottom-1 -right-1 bg-green-500 rounded-full p-0.5 border border-white" data-id="element-203">
                <CheckCircle2 size={10} className="text-white" data-id="element-204" />
              </div>
            </div>

            <div className="flex-1 pr-4 min-w-0" data-id="element-205">
              <p className={`text-sm font-bold ${currentScheme.text} leading-tight truncate`} data-id="element-206">
                {currentPurchase.name} de {currentPurchase.city}
              </p>
              <p className={`text-xs ${currentScheme.subtext} leading-tight`} data-id="element-207">
                {currentPurchase.country} · hace{' '}
                <span className="font-bold" data-id="element-208">{currentPurchase.time}</span>
              </p>
              <div className="flex items-center mt-1" data-id="element-209">
                <div className="flex" data-id="element-210">
                  {[1, 2, 3, 4, 5].map(i => <span key={i} className="text-[#fbbf24] text-[10px]" data-id="element-211">
                      ★
                    </span>)}
                </div>
                <span className={`text-[10px] ${currentScheme.subtext} ml-1 opacity-80`} data-id="element-212">
                  Verificado
                </span>
              </div>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}